import React from "react";

export default function Card({ title, subtitle, right, children, className = "" }) {
  return (
    <div className={`card ${className}`.trim()}>
      {(title || right) && (
        <div className="card-header">
          <div className="card-head-left">
            {title ? <div className="card-title">{title}</div> : null}
            {subtitle ? <div className="card-subtitle">{subtitle}</div> : null}
          </div>
          {right ? <div className="card-head-right">{right}</div> : null}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
}
